// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { sessionLogin, displayPasswordResetDialog, requestPasswordReset } from '../actions/session';
import { navEnable } from '../actions/nav';
import { getStripeAPIKey } from '../actions/actions';
import Split from 'grommet/components/Split';
import Sidebar from 'grommet/components/Sidebar';
import LoginForm from 'grommet/components/LoginForm';
import Footer from 'grommet/components/Footer';
import Section from 'grommet/components/Section';
import Anchor from 'grommet/components/Anchor';
import Button from 'grommet/components/Button';
import Layer from 'grommet/components/Layer';
import Paragraph from 'grommet/components/Paragraph';
import CloseIcon from 'grommet/components/icons/base/Close';
import Logo from './Logo';


class Login extends Component {

  constructor(props) {
    super(props);
    this._onSubmit = this._onSubmit.bind(this);
    this.displayPasswordResetDialog = this.displayPasswordResetDialog.bind(this);
    this.requestPasswordReset = this.requestPasswordReset.bind(this);
    this.showStatusAlert = this.showStatusAlert.bind(this);
    // this._setDocumentTitle(props);
    this.state = { busy: false };
  }

  componentDidMount() {
    this.props.dispatch(navEnable(false));
    this.props.dispatch(getStripeAPIKey());
  }

  componentWillReceiveProps(nextProps) {
    // this._setDocumentTitle(nextProps);
    // if (this.state.busy) {
    //   this.setState({ busy: false });
    // }
  }

  componentWillUnmount() {
    this.props.dispatch(navEnable(true));
  }

  _setDocumentTitle(props) {
    // document.title = `Login - ${props.productName || ''}`;
  }

  _onSubmit(fields) {

    // this.setState({ busy: true });
    this.props.dispatch(sessionLogin('', fields.username, fields.password));
  }

  displayPasswordResetDialog() {
    this.props.dispatch(displayPasswordResetDialog(!this.props.resetPassword));
  }

  requestPasswordReset (ev) {
      ev.preventDefault();
      if(!ev.target.elements['email'].value){
        alert("Please enter a valid email");
      }
      else{
        const email = ev.target.elements['email'].value
        this.props.dispatch(requestPasswordReset({email}));
        this.props.dispatch(displayPasswordResetDialog(!this.props.resetPassword));
      }
  }

  renderPasswordResetContent () {
    if(this.props.resetPassword) {
      return (<Layer flush={false}
          onClose={this.displayPasswordResetDialog}
          >
          <form onSubmit={this.requestPasswordReset}>
            <Button icon={<CloseIcon />}
              onClick={this.displayPasswordResetDialog}
              plain={true} style={{position: 'absolute', float:'right', right: '0'}}/>
            <div style={{textAlign: "center"}} className="heading confirmation-content">
              <Paragraph size='large'>Please enter your email to receive instructions to reset password</Paragraph>
              <Paragraph size='large'><input type="email" name="email" placeholder="Please enter your email"  className='input-email maxwidth' required/></Paragraph> 
              <Paragraph size='large'>
                <Button label='OK'
                className='lighter-font button-margin'
                type='submit'
                primary={true}
                secondary={false}
                accent={false} />
              <Button label='Cancel'
                className='lighter-font button-margin'
                onClick={this.displayPasswordResetDialog}
                primary={true}
                secondary={false}
                accent={false} />
              </Paragraph>
            </div>
          </form>  
        </Layer>);
    }
  }

  showStatusAlert () {
    if(this.props.passwordResetStatus) {
      alert (this.props.passwordResetStatus);
      this.props.dispatch(displayPasswordResetDialog(false));
    }
  }

  render() {
    const { session } = this.props;

    var loginError = session.error;

    return (
      <Section align="center">
        <LoginForm align="center"
          logo={<Logo size="large" busy={this.state.busy} />}
          onSubmit={this._onSubmit}
          errors={[loginError]}
          usernameType="text" />
          <div className="signup-nav-section login-form">
            <Button label='Forgot Password'
              className ="forgot-password-button"
              onClick = {this.displayPasswordResetDialog}
              primary={false}
              plain={true} />
            <div className="signup-content">
              No Account ? 
              <a className ="login-signup-link" href='/signup'>Sign Up</a>
            </div>
          </div>
          {this.renderPasswordResetContent()}
          {this.showStatusAlert()}
      </Section>

    );
  }
}

Login.propTypes = {
  session: PropTypes.shape({
    error: PropTypes.string
  })
};

let select = (state) => ({
  // productName: state.settings.productName.short,
  session: state.session,
  resetPassword: state.session.resetPassword,
  passwordResetStatus : state.session.passwordResetStatus
});

export default connect(select)(Login);

 /*<Split flex="left" separator={true}>

        <Sidebar justify="between" align="center" pad="none" size="large">
          <span />

          <Footer direction="row" size="small"
            pad={{horizontal: 'medium', vertical: 'small', between: 'small'}}>
            <span className="secondary">&copy; 2016 Grommet Labs</span>
          </Footer>
        </Sidebar>
      </Split>*/



// WEBPACK FOOTER //
// ./src/js/components/Login.js